import { render, staticRenderFns } from "./HorizontalFiltersItem.vue?vue&type=template&id=6e56358e&lang=pug&"
import script from "./HorizontalFiltersItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./HorizontalFiltersItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HorizontalFiltersItem.vue?vue&type=style&index=0&id=6e56358e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports